import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogTitleActions
} from "@ebscois/react-component-library";

import CallToAction from "../../CallToAction";

const CallToActionModal = ({ isOpen, onRequestClose, cta }) => {
  if (!cta) {
    return <></>;
  }

  return (
    <>
      <Dialog
        isOpen={isOpen}
        maxWidth="md"
        data-testId="ctamodal-wrapper"
        onRequestClose={onRequestClose}
      >
        <DialogTitle paddingBottom="0">
          <DialogTitleActions onRequestClose={onRequestClose} />
        </DialogTitle>
        <CallToAction cta={cta} />
      </Dialog>
    </>
  );
};

CallToActionModal.displayName = "CallToActionModal";
CallToActionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  cta: PropTypes.object
};
export default CallToActionModal;
